import { safeGet } from "@app/shared/utils/secure/safe-get";
import { createSelector } from "@ngrx/store";
import { selectDishState } from "../reducers";
import * as fromDish from "../reducers/dish.reducer";

export const selectDishesIsLoading = () =>
  createSelector(selectDishState(), fromDish.selectIsLoading);

export const selectDishEntities = () =>
  createSelector(selectDishState(), fromDish.selectGenderTypeEntities);

export const selectAllDishes = () =>
  createSelector(selectDishState(), fromDish.selectAllGenderTypes);

export const selectDishById = (id: number) =>
  createSelector(selectDishEntities(), (dishEntities) =>
    safeGet(dishEntities, String(id)),
  );
